import axios from 'axios';
import Cookies from 'js-cookie';

import { env } from '@/shared/config/env';

export const API_URL = env.apiEndpoint;

const apiClient = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = Cookies.get('refresh_token');
      const response = await axios.post(`${API_URL}auth/token/refresh/`, {
        refresh: refreshToken,
      });

      localStorage.setItem('access_token', response.data.access);
      return apiClient.request(originalRequest);
    }
    return Promise.reject(error);
  },
);

export default apiClient;
